<div class="super-admin-inner static-super-admin">
  <div class="container">
    <div class="stc-tp-blk">
      <h3> About Us</h3>
    </div>
    <div class="row">
      <div class="col-sm-12 pd-rt-30">
        <p>{{about}}</p>
        
      </div>
      <!-- <div class="col-sm-4">
        <img src="assets/img/image.jpg" />
      </div> -->
    </div>
  </div> 
</div>  